<template>
  <el-drawer class="drawer fs-credit-drawer" :withHeader="false" :show-close="false" :destroy-on-close="true" :visible.sync="is_open" size="90%"
    direction="btt">
    <el-row class="fs-site">
      <el-col class="fs-entry-header text-center">
        <h2>{{ $t('drawer.credit.header') }}</h2>
      </el-col>
      <el-col class="fs-credit-content">
        <el-row class="fs-card mb-2">
          <el-col class="fs-card-img text-right">
            <img v-if="LogoCreditCard != ''" :src="require('@/assets/'+LogoCreditCard)">
          </el-col>
          <el-col v-bind:class="(!validateCardNumber || validateLengthCardNumber) ? 'fs-card-number mb-0': 'fs-card-number'">
            <label class="text-body cl-gray-ligth">{{ $t('drawer.credit.title') }}</label><br>
            <input 
              v-model="creditNumber" 
              ref="cardnumber_input" 
              type="text" 
              inputmode="numeric" 
              autocomplete="off" 
              maxlength="16" 
              id="hide-input"
            >
              <div @click="this.$refs.cardnumber_input.focus()">
                <div 
                  class="text-body text-center under-line-1"
                  :class="{
                    'fs-bd-error': (!validateCardNumber || validateLengthCardNumber)
                  }"
                  v-for="index in 16" :key="index-1"
                >
                  {{ creditNumber[index-1] }}
                </div>
                <span v-bind:class="'text-body2 fs-error'" v-show="!validateCardNumber">{{ $t('drawer.credit.number') }}</span>
                <span v-bind:class="'text-body2 fs-error'" v-show="validateLengthCardNumber">{{ $t('drawer.credit.placeholdernumber') }}</span>
              </div>
          </el-col>
          <el-col class="fs-card-holder">
            <el-row>
              <el-col :span="12" class="mr-2">
                <label class="text-body cl-gray-ligth">{{ $t('drawer.credit.cardname') }}</label><br>
                <el-input
                  v-model="creditHolder"
                  class="text-body"
                  v-bind:class="(!validateCardHolder) ? 'input-error': ''"
                  type="text"
                  autocomplete="off"
                  maxlength="50"/>
                <span v-bind:class="'text-body2 fs-error'" v-show="!validateCardHolder">{{ $t('drawer.credit.placholdername') }}</span>
              </el-col>
              <el-col :span="5" class="fs-card-expire mr-2">
                <label class="text-body cl-gray-ligth">{{ $t('drawer.credit.expire') }}</label><br>
                <el-input
                  v-model="creditExpire"
                  class="text-body"
                  v-bind:class="(!validateCardExpire) ? 'input-error': ''"
                  placeholder="MM/YY"
                  type="text"
                  autocomplete="off"
                  maxlength="5"
                />
                <span v-bind:class="'fs-error text-body2'" v-show="!validateCardExpire">{{ $t('drawer.credit.placeholderexpire') }}</span>
              </el-col>
              <el-col :span="5" class="fs-card-cvv">
                <label class="text-body cl-gray-ligth">CVV</label><br>
                <el-input
                  style="font: small-caption;"
                  v-model="creditCVV"
                  v-bind:class="(!validateCardCVV) ? 'input-error': ''"
                  type="password"
                  inputmode="numeric"
                  autocomplete="off"
                  :disabled="disableCVV"
                  :maxlength="maxlengthCVV"/>
                <span v-bind:class="'fs-error text-body2'" v-show="!validateCardCVV">{{ $t('drawer.credit.placeholderCVV') }}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-checkbox v-model="saveCard">
              <span class="text-body">
                {{ $t('drawer.credit.savecard') }}  
              </span>
            </el-checkbox><br>
            <!-- <p class="details">
              บันทึกบัตร สำหรับการชำระเงินครั้งต่อไป โดยจะมีการ ยืนยัน OTP ทุกครั้งเพื่อความปลอดภัย
            </p> -->
          </el-col>
        </el-row>
      </el-col>
      <el-col class="fs-credit-footer">
        <el-row class="mb-2">
          <el-col :span="2">
            <i class="fs-20 cl-gray-ligth el-icon-lock"></i>
          </el-col>
          <el-col :span="22">
            <label class="text-body cl-gray-ligth">{{ $t('drawer.credit.textarea') }}</label>
          </el-col>
        </el-row>
        <fullButton :display="(AmountCart[0].is_sold_out || AmountCart[0].delivery_flag) ? true : disablePay"  :handleClick="sendCreditCard" :btn_text="totalprice" />
      </el-col>
    </el-row>
  </el-drawer>
</template>
<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import fullButton from '@/components/element/fullButton'
import Mixins from '@/utils/mixins'

export default {
  name: 'DrawerCreditCard',
  props: ['disablePayCredit', 'orderType', 'TotalCartPrice', 'deliveryFee', 'AmountCart'],
  components: {
    fullButton
  },
  mixins: [Mixins],
  data() {
    return {
      creditNumber: '',
      creditHolder: '',
      creditExpire: '',
      creditCVV: '',
      maxlengthCVV: 3,
      disableCVV: true,
      saveCard: false,
      is_open: true,
      totalprice: 0,
      disablePay: true,
      validateCardNumber: true,
      validateLengthCardNumber: false,
      validateCardHolder: true,
      validateCardExpire: true,
      validateCardCVV: true,
      LogoCreditCard: ''
    }
  },
  created() {
    if (!this.orderType) {
      this.totalprice = this.price_format(this.TotalCartPrice)
    } else if (this.orderType && this.TotalCartPrice > 0) {
      this.totalprice = this.price_format(this.TotalCartPrice + this.deliveryFee)
    } else {
      this.totalprice = this.price_format(this.TotalCartPrice)
    }
    this.totalprice = `${this.$t('drawer.editorder.payment')} ${this.price_format(this.totalprice,this.$store.getters.currency)}`
  },
  mounted() {
  },
  methods: {
    sendCreditCard () {
      if (this.creditNumber && this.creditHolder && this.creditExpire && this.creditCVV != '') {
          this.disablePay = true
          let arrExpire = this.creditExpire.split('/')
          this.$emit('validate_creditcard', {
            uid: '',
            number: this.creditNumber,
            holder: this.creditHolder,
            month: arrExpire[0],
            year: arrExpire[1],
            cvv: this.creditCVV,
            new: true,
            save: this.saveCard
          })
      } else {
        this.$alert(this.$t('alert.credit.title'), this.$t('dialog.alert'), {
          confirmButtonText: this.$t('dialog.yes')
        })
      }
    }
  },
  computed: {
  },
  watch:{
    disablePayCredit (value) {
      this.disablePay = value
    },
    is_open () {
      this.$emit('toggle_creditcard')
    },
    creditNumber (val) {
      this.creditNumber = this.replaceToNumber(val)
      if (this.creditNumber.length == 16) {
        this.validateLengthCardNumber = false
        let cardType = this.getCardType(this.creditNumber)
        this.LogoCreditCard = this.getImgCardType(this.creditNumber)
        if (cardType === null) {
          this.validateCardNumber = false
        } else if (cardType == 4) {
          this.validateCardNumber = true
          this.disableCVV = false
          this.maxlengthCVV = 4
        } else {
          this.validateCardNumber = true
          this.disableCVV = false
        }
      } else {
        this.validateCardNumber = true
        this.disableCVV = true
        this.creditCVV = ''
        this.maxlengthCVV = 3
        this.validateLengthCardNumber = true
      }
      if (this.creditNumber.length == 16 && this.validateCardNumber &&
          this.validateCardHolder && this.creditHolder != '' &&
          this.validateCardExpire && this.creditExpire.length == 5 &&
          this.validateCardCVV && this.creditCVV.length == this.maxlengthCVV)
      {
        this.disablePay = false
      } else {
        this.disablePay = true
      }
    },
    creditHolder (val) {
      let value = val.toUpperCase()
      this.creditHolder = this.replaceToCharactor(value)
      this.validateCardHolder = (this.creditHolder.length == '') ? false : true
      if (this.creditNumber.length == 16 && this.validateCardNumber &&
          this.validateCardHolder && this.creditHolder != '' &&
          this.validateCardExpire && this.creditExpire.length == 5 &&
          this.validateCardCVV && this.creditCVV.length == this.maxlengthCVV)
      {
        this.disablePay = false
      } else {
        this.disablePay = true
      }
    },
    creditExpire (value) {
      var charactor = value.substr((value.length - 1), value.length)
      if (value.length == 1) {
        var reg = new RegExp('^[\\d]+$')
        if (reg.test(charactor)) {
          value = value + ''
        } else {
          value = ''
        }
      } else if (value.length == 2) {
        var reg = new RegExp('^[\\d]+$')
        if (reg.test(charactor)) {
          value = value
        } else {
          value = value.substr(0, 1)
        }
      } else if (value.length == 3) {
        var reg = new RegExp('^[\\d]+$')
        if (reg.test(charactor)) {
          value = value.substr(0, 2) + '/' + value.substr(2, 3)
        } else {
          value = value.substr(0, 2)
        }
      } else if (value.length == 4) {
        var reg = new RegExp('^[\\d]+$')
        if (reg.test(charactor)) {
          value = value + ''
        } else {
          value = value.substr(0, 2)
        }
      } else if (value.length == 5) {
        var reg = new RegExp('^[\\d]+$')
        if (reg.test(charactor)) {
          value = value + ''
        } else {
          value = value.substr(0, 4)
        }
      }
      this.creditExpire = value
      this.validateCardExpire = (this.creditExpire.length < 5) ? false : true
      if (this.creditNumber.length == 16 && this.validateCardNumber &&
          this.validateCardHolder && this.creditHolder != '' &&
          this.validateCardExpire && this.creditExpire.length == 5 &&
          this.validateCardCVV && this.creditCVV.length == this.maxlengthCVV)
      {
        this.disablePay = false
      } else {
        this.disablePay = true
      }
    },
    creditCVV (val) {
      this.creditCVV = this.replaceToNumber(val)
      this.validateCardCVV = (this.creditCVV.length < this.maxlengthCVV) ? false : true
      if (this.creditNumber.length == 16 && this.validateCardNumber &&
          this.validateCardHolder && this.creditHolder != '' &&
          this.validateCardExpire && this.creditExpire.length == 5 &&
          this.validateCardCVV && this.creditCVV.length == this.maxlengthCVV)
      {
        this.disablePay = false
      } else {
        this.disablePay = true
      }
    }
  }
};

</script>

<style lang="scss">
.input-error input {
  border: none !important;
  border-bottom: 0.857143px solid #FF5C5C !important;
}
</style>


// WEBPACK FOOTER //
// src/components/creditcard/DrawerCreditCard.vue